import { Component, ContentChild, input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModelForm, PaginationForm } from '@shared/models';
import { ActionButton } from '@shared/models/action-button.model';
import { Column, SelectedItem } from '@shared/components/simple-table';
import { MatCheckbox } from '@angular/material/checkbox';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TableCellComponent } from '../simple-table/components/table-cell/table-cell.component';
import { ActionButtonComponent } from '../simple-table/components/action-button/action-button.component';
import { PaginatorComponent } from '../paginator/paginator.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-expandable-table',
    templateUrl: './expandable-table.component.html',
    styleUrl: './expandable-table.component.scss',
    imports: [MatCheckbox, NgClass, MatIcon, TableCellComponent, ActionButtonComponent, NgTemplateOutlet, PaginatorComponent, TranslatePipe]
})
export class ExpandableTableComponent {

  readonly columns = input<Column[]>([]);
  readonly items = input<any[]>([]);
  readonly allowSelection = input<boolean>(false);
  readonly expandable = input<boolean>(true);

  // Paginação opcional (usada no nível principal)
  readonly showPaginator = input<boolean>(false);
  readonly paginationForm = input<FormGroup<ModelForm<PaginationForm>>>();

  readonly totalItems = input<number>(0);
  readonly selectedItems = input<SelectedItem[]>([]);
  readonly actions = input<ActionButton[]>([]);

  @Output() rowExpand = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<SelectedItem[]>();
  @Output() action = new EventEmitter<ActionButton>();

  @ContentChild('expansionTemplate') expansionTemplate!: TemplateRef<any>;

  expandedRows = new Set<any>();

  toggleRow(row: any) {
    if (!this.expandable()) return;

    this.expandedRows.has(row) ? this.expandedRows.delete(row) : this.expandedRows.add(row);
    if (this.expandedRows.has(row)) {
      this.rowExpand.emit(row);
    }
  }

  onSelectionChange(row: any, checked: boolean) {
    row.selected = checked;
    this.emitSelection();
  }

  onSelectAll(checked: boolean) {
    this.items().forEach(item => item.selected = checked);
    this.emitSelection();
  }

  private emitSelection() {
    const selected = this.items()
      .filter(item => item.selected)
      .map(item => ({ id: item.id, item }));
    this.selectionChange.emit(selected);
  }

  isAllSelected(): boolean {
    return this.items().length > 0 && this.items().every(item => item.selected);
  }

  isPartiallySelected(): boolean {
    const selectedCount = this.items().filter(item => item.selected).length;
    return selectedCount > 0 && selectedCount < this.items().length;
  }

  emitAction(action: ActionButton, index: number): void {
    action.index = index;
    this.action.emit(action);
  }
}
